import { api } from './api';

const obsURL = '/obs';

// El token de admin lo inyecta prepareHeaders en api.js; la protección real
// (auth + requireAdmin) vive en el backend.
export const obsApi = api.injectEndpoints({
  endpoints: builder => ({
    getObsEvents: builder.query({
      query: (params = {}) => {
        const search = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') search.set(key, value);
        });
        const qs = search.toString();
        return `${obsURL}/events${qs ? `?${qs}` : ''}`;
      },
    }),
    getObsErrors: builder.query({
      query: (params = {}) => {
        const search = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') search.set(key, value);
        });
        const qs = search.toString();
        return `${obsURL}/errors${qs ? `?${qs}` : ''}`;
      },
    }),
    getObsSummary: builder.query({
      query: () => `${obsURL}/summary`,
    }),
    getObsSyncHealth: builder.query({
      query: campId => `${obsURL}/sync-health?campId=${campId}`,
    }),
  }),
});

export const {
  useGetObsEventsQuery,
  useGetObsErrorsQuery,
  useGetObsSummaryQuery,
  useGetObsSyncHealthQuery,
} = obsApi;
